import { type GamePageContext } from "@/features/game/state";
import { onePagerCoworldOf } from "@/features/play/state";

import { buildHref } from "@softmax/web-addresses";

import {
  addressesOf,
  searchStringOf,
  type PreviewSearch,
  type FrontDoorData,
} from "./front-door";

import { previewContent } from "@/features/preview/preview.data";

export async function readFrontDoor({
  signal,
  context,
  search,
}: {
  signal?: AbortSignal | undefined;
  context: GamePageContext;
  search: PreviewSearch;
}): Promise<FrontDoorData | null> {
  const params: { coworld: string; league?: string } = {
    coworld: context.address.slug,
  };

  if (context.league?.requestedSlug != null)
    params.league = context.league.requestedSlug;

  const address = addressesOf({
    params,
    context,
  });
  const content = await previewContent({
    signal,
    slug: address.url,
    context,
    includeDetails: false,
  });

  if (!content) return null;

  address.corpus = content.slug;
  return {
    address,
    content,
    isMember: false,
    inProgress: false,
    canEdit: false,
    canReview: false,
    doorHref: buildHref({
      name: onePagerCoworldOf(content.slug) ? "game.play" : "game.start",
      ...content.route,
      search: new URLSearchParams(searchStringOf(search)),
    }),
  };
}
